import {
  Component,
  forwardRef,
  ChangeDetectionStrategy
} from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR
} from '@angular/forms';
import { LanguageEnum } from 'src/app/constants/language.enum';

@Component({
    selector: 'app-language-picker',
    templateUrl: './language-picker.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LanguagePickerComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LanguagePickerComponent implements ControlValueAccessor {

    public languageEnum = LanguageEnum;
  languages = Object.values(LanguageEnum);
    value: LanguageEnum | null = null;
    disabled = false;

    // callbacks
    private onChange: (value: LanguageEnum | null) => void = () => { };
    private onTouched: () => void = () => { };
    get displayvalue(): string {
        return this.value?.toString()?.toLowerCase() ?? "";
    }
    // UI interaction
    selectLanguage(lang: LanguageEnum) {
        if (this.disabled) return;

        this.value = lang;
        this.onChange(this.value);
        this.onTouched();
    }

    // ControlValueAccessor methods
    writeValue(value: LanguageEnum | null): void {
        this.value = value;
    }

    registerOnChange(fn: (value: LanguageEnum | null) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}